export default "__VITE_ASSET__9b4ea181__"